<template>
    <div class="new-certity-result-wrapper">
        <div class="pc-result-main">
            <div class="result-head-con">
                <div class="head-main-con clearfix">
                    <img :src="logo" alt class="fl logo-img-val" />
                    <div class="fl head-title-val">证书/成绩查询系统</div>
                    <div class="fr back-site-btn">
                        <router-link :to="{ name: 'certifyIndex' }"> <i class="wl-icon-fanhui2"></i>返回主站 </router-link>
                    </div>
                </div>
            </div>
            <div class="query-main-con">
                <div class="query-menu-con">
                    <i class="wl-icon-weibiaoti1"></i>
                    <span @click="toHome" class="sp-to-home">首页</span>
                    <span class="sp-lable-line">></span>
                    <span class="sp-active-label" v-if="type == 1">证书查询</span>
                    <span class="sp-active-label" v-if="type == 2">成绩查询</span>
                </div>
                <div class="step-main-con">
                    <el-steps :active="activeIndex" class="active-step-con">
                        <el-step title="选择考试项目" icon="wl-icon-kaoshixiangmu"></el-step>
                        <el-step title="输入条件查询" icon="wl-icon-chaxun2"></el-step>
                        <el-step :title="certifyTitle" :icon="typeIcon"></el-step>
                    </el-steps>
                    <div class="step-all-con">
                        <div v-if="activeIndex == 1" class="step-one-con">
                            <div class="step-title-con">
                                <i class="wl-icon-xiaoyuan"></i>
                                选择考试项目
                            </div>
                            <ul class="cerfity-list-ul clearfix" v-for="(item, index) in certificateList" :key="index">
                                <div class="type-title" v-if="item.typeList.length > 0"><i class="wl-icon-quanbu"></i> {{ item.typeName }}</div>
                                <li class="list-ul-li fl" v-for="(item, index) in item.typeList" :key="index" :class="{ isCanQuery: item.isQuery == '1' }">
                                    <div v-if="item.linkUrl == ''" @click="searchCerfity(item.value, item.isQuery, item.isScoreGrade, item.isCertificateGrade, item.label, item.info)">{{ item.info.typeName || item.label }}</div>
                                    <a v-else class="a-link" :href="item.linkUrl" style="color: black" target="_blank">{{ item.info.typeName || item.label }}</a>
                                </li>
                            </ul>
                            <div class="p-tip-val">注：灰色背景项目暂不支持查询</div>
                        </div>
                        <div v-if="activeIndex == 2" class="step-one-con">
                            <div class="step-title-con">
                                <i class="wl-icon-xiaoyuan"></i>
                                {{ certifyName }}-输入查询条件
                            </div>
                            <div class="search-form-con">
                                <el-form ref="form" :model="form" label-width="100px" class="form-input-con">
                                    <el-form-item label="报考级别：" prop="level" v-if="(isScoreGrade == 1 && type == 2) || (type == 1 && isCertificateGrade == 1)">
                                        <el-select v-model="form.level" placeholder="请选择报考级别">
                                            <el-option v-for="(item, index) in levelOption" :key="index" :label="item.lable" :value="item.value"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <p class="input-tip-val" v-if="type == 1 && certifyId != 'wbkraxarnlxhf8lvk6cumg'">证书编号、姓名、和身份证件号码至少输入两项</p>
                                    <p class="input-tip-val" v-if="type == 1 && certifyId == 'wbkraxarnlxhf8lvk6cumg'">身份证号、姓名</p>
                                    <p class="input-tip-val" v-if="type == 2 && certifyId != 'wbkraxarnlxhf8lvk6cumg'">准考证号、姓名、和身份证件号码至少输入两项</p>
                                    <p class="input-tip-val" v-if="type == 2 && certifyId == 'wbkraxarnlxhf8lvk6cumg'">准考证号、姓名</p>
                                    <el-form-item label="证书编号：" prop="cerfityNum" v-if="type == 1 && certifyId != 'wbkraxarnlxhf8lvk6cumg'">
                                        <el-input v-model="form.cerfityNum"></el-input>
                                    </el-form-item>
                                    <el-form-item label="准考证号：" prop="ZKZ_ID" v-if="type == 2">
                                        <el-input v-model="form.ZKZ_ID"></el-input>
                                    </el-form-item>
                                    <el-form-item label="身份证号：" prop="IDNuber">
                                        <el-input v-model="form.IDNuber"></el-input>
                                    </el-form-item>
                                    <el-form-item label="姓名：" prop="name">
                                        <el-input v-model="form.name"></el-input>
                                    </el-form-item>

                                    <el-form-item>
                                        <el-button type="primary" @click="queryBtn" class="query-result-btn">查询</el-button>
                                        <el-button @click="resetForm()" class="reset-form-btn">重填</el-button>
                                    </el-form-item>
                                </el-form>
                            </div>
                            <div class="guide-search-main">
                                <div class="grade-search-con clearfix">
                                    <div class="fl query-guide-con">
                                        <div class="clearfix">
                                            <div class="icon-head-con head-con-1 fl">
                                                <i class="wl-icon-nanbei"></i>
                                            </div>
                                            <span class="sp-label-title fl">查询指南</span>
                                        </div>
                                        <p class="p-grade-title-1">任意输入以下组合内容即可查询：</p>
                                        <ul class="guide-ul-con" v-if="type == 1 && certifyId != 'wbkraxarnlxhf8lvk6cumg'">
                                            <li>1.身份证号+证书编号</li>
                                            <li>2.身份证号+姓名</li>
                                            <li>3.证书编号+姓名</li>
                                            <li>4.姓名+身份证号+证书编号</li>
                                        </ul>
                                        <ul class="guide-ul-con" v-if="type == 1 && certifyId == 'wbkraxarnlxhf8lvk6cumg'">
                                            <li>1.身份证号+姓名</li>
                                        </ul>
                                        <ul class="guide-ul-con" v-if="type == 2 && certifyId != 'wbkraxarnlxhf8lvk6cumg'">
                                            <li>1.身份证号+准考证号</li>
                                            <li>2.身份证号+姓名</li>
                                            <li>3.准考证号+姓名</li>
                                            <li>4.姓名+身份证号+准考证号</li>
                                        </ul>
                                        <ul class="guide-ul-con" v-if="type == 2 && certifyId == 'wbkraxarnlxhf8lvk6cumg'">
                                            <li>1.准考证号+姓名</li>
                                        </ul>
                                    </div>
                                    <div class="fr care-way-con">
                                        <div class="clearfix">
                                            <div class="icon-head-con head-con-2 fl">
                                                <i class="wl-icon-exclamation"></i>
                                            </div>
                                            <span class="sp-label-title fl">注意事项</span>
                                        </div>
                                        <p class="p-care-con">全国成绩/证书联网查询系统仅限于查询中国物流与采购联合会、北京中物联物流采购培训中心 颁发的物流、采购及供应链相关证书； 数据上传和审核需要一定的时间周期，如急需核实证书真伪，可致电:010-83775927。</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="activeIndex == 3" class="step-one-con">
                            <div class="step-title-con">
                                <i class="wl-icon-xiaoyuan"></i>
                                {{ certifyName }}-查询结果
                            </div>
                            <!--  物流管理职业技能等级证书 证书模板 -->
                            <div class="canvas-main-con" v-if="type == 1 && certifyId == 'wbkraxarnlxhf8lvk6cumg'">
                                <canvas class="canvas" width="900px" height="650px" id="canvas"></canvas>
                            </div>

                            <!--  物流从业人员考试证书 证书模板 -->
                            <div class="canvas-main-con" v-if="type == 1 && certifyId == 'iirhahmroybhjalilwmg' && stuInfo.examTimeYear > 2020">
                                <canvas class="canvas" width="690px" height="900px" id="canvas"></canvas>

                                <el-button class="continue-to-btn" @click="downloadCert()">下载证书</el-button>
                            </div>

                            <!--  物流采购人员考试证书 证书模板 -->
                            <div class="canvas-main-con" v-if="type == 1 && certifyId == 'nqdhahmr2ivexjbzrrigna' && stuInfo.examTimeYear > 2020">
                                <canvas class="canvas" width="690px" height="900px" id="canvas"></canvas>

                                <el-button class="continue-to-btn" @click="downloadCert()">下载证书</el-button>
                            </div>
                            <!-- 物流师 -->
                            <div class="canvas-main-con" v-if="type == 1 && certifyId == 'z733an6u3kfcxul99vd5a'">
                                <!-- <canvas class="canvas" width="900px" height="650px" id="canvas"></canvas> -->
                                <img v-if="stuInfo.certificateUrl != ''" class="canvas" width="650px" height="900px" :src="stuInfo.certificateUrl" />
                                <p style="font-size: 18px; color: red" v-if="stuInfo.certificateUrl == ''">头像未上传，无法生成在线证书，请联系管理员。</p>
                                <!-- <el-button class="continue-to-btn" @click="downloadCert()">下载证书</el-button> -->
                                <a v-if="stuInfo.certificateUrl != ''" class="continue-to-btn" :href="stuInfo.downloadUrl">下载证书</a>
                            </div>
                            <!-- 采购师 -->
                            <div class="canvas-main-con" v-if="type == 1 && certifyId == 'eij3an6uszpixc6vt975ea'">
                                <img v-if="stuInfo.certificateUrl != ''" class="canvas" width="650px" height="900px" :src="stuInfo.certificateUrl" />
                                <p style="font-size: 18px; color: red" v-if="stuInfo.certificateUrl == ''">头像未上传，无法生成在线证书，请联系管理员。</p>
                                <a v-if="stuInfo.certificateUrl != ''" class="continue-to-btn" :href="stuInfo.downloadUrl">下载证书</a>
                            </div>
                            <!-- 物流职业经理 -->
                            <div class="canvas-main-con" v-if="type == 1 && certifyId == 'kqiahmrorrcurlncm3h9q'">
                                <img v-if="stuInfo.certificateUrl != ''" class="canvas" width="900px" height="650px" :src="stuInfo.certificateUrl" />
                                <p style="font-size: 18px; color: red" v-if="stuInfo.certificateUrl == ''">头像未上传，无法生成在线证书，请联系管理员。</p>
                                <a v-if="stuInfo.certificateUrl != ''" class="continue-to-btn" :href="stuInfo.downloadUrl">下载证书</a>
                            </div>
                            <!-- 供应链管理师 -->
                            <div class="canvas-main-con" v-if="type == 1 && certifyId == '4lc1accv66bdbuvnmhovpq'">
                                <img v-if="stuInfo.certificateUrl != ''" class="canvas" width="900px" height="650px" :src="stuInfo.certificateUrl" />
                                <p style="font-size: 18px; color: red" v-if="stuInfo.certificateUrl == ''">头像未上传，无法生成在线证书，请联系管理员。</p>
                                <a v-if="stuInfo.certificateUrl != ''" class="continue-to-btn" :href="stuInfo.downloadUrl">下载证书</a>
                            </div>
                            <!-- 合格证书 -->
                            <div class="canvas-main-con" v-if="type == 1 && certifyId == 'afioaxsvpl1bydz0rxzayg'">
                                <img v-if="stuInfo.certificateUrl != ''" class="canvas" width="900px" height="650px" :src="stuInfo.certificateUrl" />
                                <p style="font-size: 18px; color: red" v-if="stuInfo.certificateUrl == ''">头像未上传，无法生成在线证书，请联系管理员。</p>
                                <a v-if="stuInfo.certificateUrl != ''" class="continue-to-btn" :href="stuInfo.downloadUrl">下载证书</a>
                            </div>
                            <div class="canvas-main-con" v-if="type == 1 && certifyId == 'cmikalcuwyvf2xg1bebsq'">
                                <img class="exam-cover-img" :src="stuInfo.certificateUrl" alt="" />
                            </div>
                            <div class="basic-info-con" v-if="type == 1 && certifyId != 'cmikalcuwyvf2xg1bebsq'">
                                <div class="info-head-con">
                                    <i class="wl-icon-jibenxinxi"></i>
                                    <span>基本信息</span>
                                    <span class="small-title-con">/Basic Information</span>
                                </div>
                                <div class="clearfix c-info-main">
                                    <div class="fl c-info-item c-info-item-label">姓名：</div>
                                    <div class="fl c-info-item c-info-item-val">
                                        {{ stuInfo.studentName }}
                                    </div>
                                    <div class="fl c-info-item c-info-item-label">姓名拼音：</div>
                                    <div class="fl c-info-item c-info-item-val">
                                        {{ stuInfo.studentNamePinyin}}
                                    </div>
                                    <div class="fl c-info-item c-info-item-label" v-if="certifyId != 'wbkraxarnlxhf8lvk6cumg'">身份证号：</div>
                                    <div class="fl c-info-item c-info-item-val" v-if="certifyId != 'wbkraxarnlxhf8lvk6cumg'">
                                        {{ stuInfo.idCard }}
                                    </div>
                                    <div class="fl c-info-item c-info-item-label">考核站点：</div>
                                    <div class="fl c-info-item c-info-item-val">
                                        {{ stuInfo.siteName }}
                                    </div>
                                </div>
                                <div class="info-head-con">
                                    <i class="wl-icon-zhengshu"></i>
                                    <span>证书信息</span>
                                    <span class="small-title-con">/Certificate information</span>
                                </div>
                                <div class="clearfix c-info-main">
                                    <div class="fl c-info-item c-info-item-label">证书等级：</div>
                                    <div class="fl c-info-item c-info-item-val">
                                        {{ stuInfo.examinationGrade }}
                                    </div>
                                    <div class="fl c-info-item c-info-item-label">证书编号：</div>
                                    <div class="fl c-info-item c-info-item-val">
                                        {{ stuInfo.certificateNum }}
                                    </div>
                                    <div class="fl c-info-item c-info-item-label">发证机构：</div>
                                    <div class="fl c-info-item c-info-item-val" v-if="certifyId == 'wbkraxarnlxhf8lvk6cumg'">北京中物联物流采购培训中心</div>
                                    <div class="fl c-info-item c-info-item-val" v-else>中国物流与采购联合会</div>
                                    <div class="fl c-info-item c-info-item-label">发证日期：</div>
                                    <div class="fl c-info-item c-info-item-val">
                                        {{ stuInfo.dateofIssue }}
                                    </div>
                                </div>
                            </div>
                            <!-- 成绩 -->
                            <el-table :data="gradeList" class="result-table-con" v-if="type == 2">
                                <el-table-column prop="studentName" label="姓名"></el-table-column>
                                <el-table-column prop="idCard" label="身份证号" width="180" v-if="certifyId != 'wbkraxarnlxhf8lvk6cumg'"></el-table-column>
                                <el-table-column prop="siteName" label="考点"></el-table-column>
                                <el-table-column prop="examTime" label="考试时间"></el-table-column>
                                <el-table-column prop="qualifiedState" label="考试结果"></el-table-column>
                                <el-table-column prop="score" label="考试成绩">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.qualifiedState == '缺考'">--</span>
                                        <span v-else>{{ scope.row.score }}</span>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <div class="canvas-main-con" v-show="type == 2&&gradeList.length>0" v-for="(item,index) in gradeList" :key="index">
                                <img class="exam-cover-img" :src="item.imageUrl" alt="" />
                                <el-button class="continue-to-btn" v-if="item.imageUrl" @click="downloadImage(item.imageUrl)">下载</el-button>
                            </div>
                            <div class="continue-to-query">
                                <el-button class="continue-to-btn" @click="continueBtn">继续查询</el-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="footer-main-con">
                <p class="p-footer-1">Copyright 2000-2022 in 中国物流与采购联合会、北京中物联物流采购培训中心版权所有</p>
                <a href="https://beian.miit.gov.cn/">京ICP备19032250号-1</a>
            </div>
        </div>
        <!-- 移动端 -->
        <div class="ph-result-main">
            <div class="ph-result-head-mian clearfix">
                <img :src="logo" alt class="fl logo-img-val" />
            </div>
            <div class="ph-nav-con">
                <i class="wl-icon-weibiaoti1"></i>
                <span @click="toHome" class="sp-to-home">首页</span>
                <span class="sp-lable-line">></span>
                <span class="sp-active-label" v-if="type == 1">证书查询</span>
                <span class="sp-active-label" v-if="type == 2">成绩查询</span>
            </div>
            <div class="ph-step-main">
                <el-steps :active="activeIndex" class="active-step-con">
                    <el-step title="选择考试项目" icon="wl-icon-kaoshixiangmu"></el-step>
                    <el-step title="输入条件查询" icon="wl-icon-chaxun2"></el-step>
                    <el-step :title="certifyTitle" :icon="typeIcon"></el-step>
                </el-steps>
            </div>
            <div class="ph-step-all-con">
                <div class="ph-step-one-con ph-step-1" v-if="activeIndex == 1">
                    <div class="step-head-con">
                        <i class="wl-icon-xiaoyuan"></i>
                        选择考试项目
                    </div>
                    <ul class="ph-cerfity-list-ul" v-for="(item, index) in certificateList" :key="index">
                        <div class="type-title" v-if="item.typeList.length > 0"><i class="wl-icon-quanbu"></i> {{ item.typeName }}</div>
                        <li class="cerfity-li-item" v-for="(item, index) in item.typeList" :key="index" :class="{ isCanQuery: item.isQuery == '1' }">
                            <div v-if="item.linkUrl == ''" @click="searchCerfity(item.value, item.isQuery, item.isScoreGrade, item.isCertificateGrade, item.label, item.info)">{{ item.info.typeName || item.label }}</div>
                            <a v-else class="a-link" :href="item.linkUrl" style="color: black" target="_blank">{{ item.info.typeName || item.label }}</a>
                        </li>
                    </ul>
                    <p class="p-notice-con">注：灰色背景项目暂不支持查询</p>
                </div>
                <div class="ph-step-one-con ph-step-2" v-if="activeIndex == 2">
                    <div class="step-head-con">
                        <i class="wl-icon-xiaoyuan"></i>
                        {{ certifyName }}-输入查询条件
                    </div>
                    <div class="ph-search-form-con">
                        <el-form ref="form" :model="form" label-width="85px" class size="small">
                            <el-form-item label="报考级别：" prop="level" v-if="(isScoreGrade == 1 && type == 2) || (type == 1 && isCertificateGrade == 1)">
                                <el-select v-model="form.level" placeholder="请选择报考级别">
                                    <el-option v-for="(item, index) in levelOption" :key="index" :label="item.lable" :value="item.value"></el-option>
                                </el-select>
                            </el-form-item>
                            <p class="input-tip-val" v-if="type == 1 && certifyId != 'wbkraxarnlxhf8lvk6cumg'">证书编号、姓名、和身份证件号码至少输入两项</p>
                            <p class="input-tip-val" v-if="type == 1 && certifyId == 'wbkraxarnlxhf8lvk6cumg'">证书编号、姓名</p>
                            <el-form-item label="证书编号：" prop="cerfityNum" v-if="type == 1 && certifyId != 'wbkraxarnlxhf8lvk6cumg'">
                                <el-input v-model="form.cerfityNum"></el-input>
                            </el-form-item>
                            <el-form-item label="准考证号：" prop="ZKZ_ID" v-if="type == 2">
                                <el-input v-model="form.ZKZ_ID"></el-input>
                            </el-form-item>
                            <el-form-item label="姓名：" prop="name">
                                <el-input v-model="form.name"></el-input>
                            </el-form-item>
                            <el-form-item label="身份证号：" prop="IDNuber" v-if="certifyId != 'wbkraxarnlxhf8lvk6cumg'">
                                <el-input v-model="form.IDNuber"></el-input>
                            </el-form-item>
                            <p class="input-tip-val" v-if="type == 2 && certifyId != 'wbkraxarnlxhf8lvk6cumg'">准考证号、姓名、和身份证件号码至少输入两项</p>
                            <p class="input-tip-val" v-if="type == 2 && certifyId == 'wbkraxarnlxhf8lvk6cumg'">准考证号、姓名</p>
                            <el-form-item>
                                <el-button type="primary" @click="queryBtn" class="query-result-btn">查询</el-button>
                                <el-button @click="resetForm()" class="reset-form-btn">重填</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
                <div class="ph-step-one-con ph-step-3" v-if="activeIndex == 3">
                    <div class="step-head-con">
                        <i class="wl-icon-xiaoyuan"></i>
                        {{ certifyName }}-查询结果
                    </div>
                    <div v-if="type == 1 && certifyId == 'wbkraxarnlxhf8lvk6cumg'" class="cerfity-img-con">
                        <img :src="certificate" alt />
                    </div>
                    <div class="cerfity-img-con" v-if="type == 1 && certifyId == 'cmikalcuwyvf2xg1bebsq'">
                        <img :src="stuInfo.certificateUrl" alt="" />
                    </div>
                    <div class="basic-info-con" v-if="type == 1 && certifyId != 'cmikalcuwyvf2xg1bebsq'">
                        <div class="info-head-con">
                            <i class="wl-icon-jibenxinxi"></i>
                            <span>基本信息</span>
                            <span class="small-title-con">/Basic Information</span>
                        </div>
                        <div class="clearfix c-info-main">
                            <div class="fl c-info-item c-info-item-label">姓名：</div>
                            <div class="fl c-info-item c-info-item-val">
                                {{ stuInfo.studentName }}
                            </div>
                            <div class="fl c-info-item c-info-item-label">姓名拼音：</div>
                            <div class="fl c-info-item c-info-item-val">
                                {{ stuInfo.studentNamePinyin}}
                            </div>
                            <div class="fl c-info-item c-info-item-label" v-if="certifyId != 'wbkraxarnlxhf8lvk6cumg'">身份证号：</div>
                            <div class="fl c-info-item c-info-item-val" v-if="certifyId != 'wbkraxarnlxhf8lvk6cumg'">
                                {{ stuInfo.idCard }}
                            </div>
                            <div class="fl c-info-item c-info-item-label">考核站点：</div>
                            <div class="fl c-info-item c-info-item-val">
                                {{ stuInfo.siteName }}
                            </div>
                        </div>
                        <div class="info-head-con">
                            <i class="wl-icon-zhengshu"></i>
                            <span>证书信息</span>
                            <span class="small-title-con">/Certificate information</span>
                        </div>
                        <div class="clearfix c-info-main">
                            <div class="fl c-info-item c-info-item-label">证书等级：</div>
                            <div class="fl c-info-item c-info-item-val">
                                {{ stuInfo.examinationGrade }}
                            </div>
                            <div class="fl c-info-item c-info-item-label">证书编号：</div>
                            <div class="fl c-info-item c-info-item-val">
                                {{ stuInfo.certificateNum }}
                            </div>
                            <div class="fl c-info-item c-info-item-label">发证机构：</div>
                            <div class="fl c-info-item c-info-item-val" v-if="certifyId == 'wbkraxarnlxhf8lvk6cumg'">北京中物联物流采购培训中心</div>
                            <div class="fl c-info-item c-info-item-val" v-else>中国物流与采购联合会</div>
                            <div class="fl c-info-item c-info-item-label">发证日期：</div>
                            <div class="fl c-info-item c-info-item-val">
                                {{ stuInfo.dateofIssue }}
                            </div>
                        </div>
                    </div>
                    <div class="result-table-main">
                        <el-table :data="gradeList" class="result-table-con" v-if="type == 2" size="small">
                            <el-table-column fixed prop="studentName" label="姓名"></el-table-column>
                            <el-table-column prop="idCard" label="身份证号" width="180" v-if="certifyId != 'wbkraxarnlxhf8lvk6cumg'"></el-table-column>
                            <el-table-column prop="siteName" label="考点"></el-table-column>
                            <el-table-column prop="examTime" label="考试时间"></el-table-column>
                            <el-table-column prop="qualifiedState" label="考试结果"></el-table-column>
                            <el-table-column prop="score" label="考试成绩">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.qualifiedState == '缺考'">--</span>
                                    <span v-else>{{ scope.row.score }}</span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="canvas-main-con" v-show="type == 2&&gradeList.length>0" v-for="(item,index) in gradeList" :key="index">
                        <img class="exam-cover-img" :src="item.imageUrl" alt="" />
                        <el-button class="continue-to-btn" v-if="item.imageUrl" @click="downloadImage(item.imageUrl)">下载</el-button>
                    </div>
                    <div class="continue-to-query">
                        <el-button class="continue-to-btn" size="small" @click="continueBtn">继续查询</el-button>
                    </div>
                </div>
            </div>
            <div class="footer-main-con">
                <p class="p-footer-1">
                    Copyright 2000-2022
                    <a href="https://beian.miit.gov.cn/">京ICP备19032250号-1</a>
                </p>
                <p>中国物流与采购联合会、北京中物联物流采购培训中心版权所有</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            logo: require("assets/images/ce-qeury-logo.png"),
            activeIndex: 1,
            cerfityList: [],
            form: {
                level: "",
                cerfityNum: "",
                name: "",
                IDNuber: "",
                ZKZ_ID: "",
            },
            levelOption: [],
            certifyId: "",
            certifyName: "",
            isScoreGrade: "",
            isCertificateGrade: "",
            certificateInfo: {},
            stuInfo: {
                studentName: "张三",
                studentNamePinyin: "zhang san",
                examTime: "2020-12-01",
                examinationGrade: "90",
                examYMEnglish: "june",
                examinationGradeEnglish: "middle",
                idCard: "123123123",
                certificateNum: "123123123",
                dateofIssue: "2020-10-10",
                studentUrl: require("assets/images/default_avatar3.png"),
            },
            certificate: require("assets/images/certificate.png"),
            certificateCY: require("assets/images/certificateCY.jpg"), //物流从业
            certificateCG: require("assets/images/certificateCG.jpg"), //采购从业
            dateMoth: ["", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
            dateGradeEnglish: [
                {
                    value: "物流员（仓储与配送）",
                    label: "Basic level(Warehousing&Distribution).",
                },
                {
                    value: "物流员（货物运输）",
                    label: "Basic level(Transport of goods).",
                },
                {
                    value: "助理级",
                    label: "Junior Level.",
                },
                {
                    value: "中级",
                    label: "Middle Level.",
                },
                {
                    value: "高级",
                    label: "Senior Level.",
                },
                {
                    value: "见习中级",
                    label: "Middle Level (Intern).",
                },
                // {
                //     value: "中级",
                //     label: "Middle Level.",
                // },
                // {
                //     value: "高级",
                //     label: "Senior Level.",
                // },
                {
                    value: "注册级",
                    label: "Registered  Level.",
                },
            ],
            certifyUrl: "",
            certifyTitle: "",
            gradeList: [],
            certificateList: [],
            typeIcon: "",
        };
    },
    props: {
        // 1 证书 2 成绩
        type: {
            type: [Number, String],
            default: "",
        },
    },
    created() {
        //    this.activeIndex = 3;
        //    this.form.level="vk3hahmrz69dtb6t2ymtfw";
        //    this.form.name="陈莹";
        //    this.form.IDNuber="420116198910171505";
        //    this.certifyId="nqdhahmr2ivexjbzrrigna";
        //    this. queryBtn();
        // //    this.type=1;
        //    return;
        // this.getCerfityList();
        this.getCertificateTypeConfig();
        this.certifyTitle = this.type == 1 ? "查看证书" : "查看成绩";
        this.typeIcon = this.type == 1 ? "wl-icon-zhengshu1" : "wl-icon-xuexichengji";
    },
    methods: {
        continueBtn() {
            this.activeIndex = 1;
            this.resetForm();
        },
        getCertificateTypeConfig() {
            this.$http
                .post("/api/XOrg/CertificateTypeConfig/getCertificateTypeConfig", {
                    isShowScore: this.type == 2 ? 1 : 0,
                    isShowCertificate: this.type == 1 ? 1 : 0,
                    type: 0,
                })
                .then((rst) => {
                    if (rst.code > 0) {
                        this.certificateList = rst.list;
                    }
                });
        },
        searchCerfity(id, isQuery, isScoreGrade, isCertificateGrade, label, info) {
            if (isQuery == "1") {
                return this.$message.warning("暂不可查询!");
            }
            this.certifyId = id;
            this.activeIndex = 2;
            this.isScoreGrade = isScoreGrade;
            this.isCertificateGrade = isCertificateGrade;
            this.certifyName = label;
            this.certificateInfo = info;
            this.$http
                .post("/api/XOrg/CertGradeMgr/getCertificateGrade", {
                    typeId: id,
                })
                .then((res) => {
                    if (res.code > 0) {
                        this.levelOption = res.list;
                    } else {
                        return;
                    }
                });
        },
        resetForm() {
            this.form.level = "";
            this.form.cerfityNum = "";
            this.form.name = "";
            this.form.IDNuber = "";
            this.form.ZKZ_ID = "";
            // this.$refs[formName].resetFields();
        },
        queryBtn() {
            var that = this;
            // 证书查询
            if (this.type == 1) {
                this.$http
                    .post("/api/XOrg/CertificateManager/getCertificateInfo", {
                        name: this.form.name,
                        IDNum: this.form.IDNuber,
                        cerfityNum: this.form.cerfityNum,
                        ExaminationGradeId: this.form.level,
                        CertificateTypeId: this.certifyId,
                        startYaer: this.certificateInfo.startYear,
                        endYear: this.certificateInfo.endYear,
                    })
                    .then((res) => {
                        if (res.code > 0) {
                            that.stuInfo = res.info;
                            that.activeIndex = 3;
                            if (that.certifyId == "wbkraxarnlxhf8lvk6cumg") {
                                that.$nextTick(() => {
                                    that.getCanvas();
                                });
                            } else if (that.certifyId == "iirhahmroybhjalilwmg" && res.info.examTimeYear > 2020) {
                                //物流从业
                                that.$nextTick(() => {
                                    that.getCanvasCY();
                                });
                            } else if (that.certifyId == "nqdhahmr2ivexjbzrrigna" && res.info.examTimeYear > 2020) {
                                that.$nextTick(() => {
                                    that.getCanvasCG();
                                });
                            }
                        } else {
                            return this.$message.warning(res.msg);
                        }
                    });
            }
            if (this.type == 2) {
                this.$http
                    .post("/api/XOrg/ResultsManager/getStudentResultList", {
                        studentName: this.form.name,
                        idCard: this.form.IDNuber,
                        ExaminationGradeId: this.form.level,
                        CertificateTypeId: this.certifyId,
                        ZKZ_ID: this.form.ZKZ_ID,
                        startYaer: this.certificateInfo.startYear,
                        endYear: this.certificateInfo.endYear,
                    })
                    .then((res) => {
                        if (res.code > 0) {
                            that.gradeList = res.list;
                            that.activeIndex = 3;
                        } else {
                            return this.$message.warning(res.msg);
                        }
                    });
            }
        },
        getCanvas() {
            var canvas = document.getElementById("canvas");
            console.log(canvas);
            var ctx = canvas.getContext("2d");
            // 绘制背景图
            var image1 = new Image();
            image1.src = this.certificate;
            var promise1 = new Promise((resolve, reject) => {
                image1.onload = function () {
                    ctx.drawImage(image1, 0, 0, 900, 650);
                    resolve("ok");
                };
            });
            promise1
                .then((res) => {
                    if (res == "ok") {
                        // 学生姓名
                        ctx.font = "14px Arial";
                        ctx.fillStyle = "#1c1417";
                        ctx.fillText(`${this.stuInfo.studentName}`, 730, 340);
                        ctx.stroke();
                        // 学生姓名（拼音）
                        ctx.font = "14px Arial";
                        ctx.fillStyle = "#1c1417";
                        ctx.fillText(`${this.stuInfo.studentNamePinyin}`, 710, 370);
                        ctx.stroke();
                        // 参加物流考试时间
                        ctx.font = "16px Source Han Sans CN";
                        ctx.fillStyle = "#1c1417";
                        ctx.fillText(`${this.stuInfo.examTime}`, 145, 198);
                        // 级别（初级 中级 高级）
                        ctx.font = "16px Source Han Sans CN";
                        ctx.fillStyle = "#1c1417";
                        ctx.fillText(`${this.stuInfo.examinationGrade}`, 359, 228);
                        // 参加物流考试的时间（英文）
                        ctx.font = "italic 12px Arial";
                        ctx.fillStyle = "#1c1417";
                        ctx.fillText(`in ${this.stuInfo.examYMEnglish}`, 555, 285);
                        // 级别（初级 中级 高级）（英文）
                        ctx.font = "italic 12px Arial";
                        ctx.fillStyle = "#1c1417";
                        ctx.fillText(`${this.stuInfo.examinationGradeEnglish}`, 242, 313);
                        // 身份证
                        ctx.font = "16px Source Han Sans CN";
                        ctx.fillStyle = "#1c1417";
                        ctx.fillText(`${this.stuInfo.idCard}`, 230, 380);
                        // 证书编号
                        ctx.font = "16px Source Han Sans CN";
                        ctx.fillStyle = "#1c1417";
                        ctx.fillText(`${this.stuInfo.certificateNum}`, 230, 420);
                        // 发放证书时间
                        ctx.font = "16px Source Han Sans CN";
                        ctx.fillStyle = "#1c1417";
                        ctx.fillText(`${this.stuInfo.dateofIssue}`, 230, 505);
                        var image = new Image();
                        image.setAttribute("crossOrigin", "Anonymous");
                        image.src = this.stuInfo.studentUrl;
                        image.onload = () => {
                            ctx.drawImage(image, 698, 190, 100, 130);
                            this.certifyUrl = canvas.toDataURL("image/jpeg");
                            console.log(this.certifyUrl);
                        };
                    }
                })
                .catch((err) => {});
        },
        getCanvasCY() {
            var canvas = document.getElementById("canvas");
            console.log(canvas);
            var ctx = canvas.getContext("2d");
            // 绘制背景图
            var image1 = new Image();
            image1.src = this.certificateCY;
            var promise1 = new Promise((resolve, reject) => {
                image1.onload = function () {
                    ctx.drawImage(image1, 0, 0, 650, 900);
                    resolve("ok");
                };
            });
            promise1.then((res) => {
                if (res == "ok") {
                    //考生照片
                    var promise2 = new Promise((r1, r2) => {
                        var img = new Image();
                        img.crossOrigin = "*";

                        img.src = this.stuInfo.studentUrl + "?v=" + Math.random();

                        img.onload = function () {
                            ctx.drawImage(img, 412, 350, 95, 130);
                        };
                    });

                    // 上部年
                    ctx.font = "13px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.examTimeYear}`, 148, 362);
                    // 下部年
                    ctx.font = "15px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.examTimeYearFZ}`, 385, 775);

                    // 上部月
                    ctx.font = "13px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.examTimeMonth}`, 210, 362);

                    // 下部月
                    ctx.font = "15px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.examTimeMonthFZ}`, 450, 775);

                    // 上部日
                    ctx.font = "13px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.examTimeDay}`, 252, 362);

                    // 下部日
                    ctx.font = "15px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.examTimeDayFZ}`, 488, 775);

                    //英文日期
                    ctx.font = "9px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.dateMoth[this.stuInfo.examTimeMonths]} ${this.stuInfo.examTimeDay} ${this.stuInfo.examTimeYear}`, 135, 556);

                    //学生姓名
                    ctx.font = "13px HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.studentName}`, 428, 518);
                    ctx.stroke();
                    // 学生姓名（拼音）
                    ctx.font = "9px HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.studentNamePinyin}`, 255, 512);
                    ctx.stroke();

                    // 身份证
                    ctx.font = "13px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.idCard}`, 428, 558);
                    // 证书编号
                    ctx.font = "13px HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.certificateNum}`, 428, 595);

                    // 级别（初级 中级 高级）
                    ctx.font = "13px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.examinationGrade}`, 200, 415);
                    debugger;
                    //级别（初级 中级 高级）（英文）
                    ctx.font = "9px HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    let str = this.dateGradeEnglish.find((item, index) => {
                        return item.value === this.stuInfo.examinationGrade;
                    });
                    ctx.fillText(`${str.label}`, 195, 600);
                }
            });
        },
        getCanvasCG() {
            var canvas = document.getElementById("canvas");
            console.log(canvas);
            var ctx = canvas.getContext("2d");
            // 绘制背景图
            var image1 = new Image();

            image1.src = this.certificateCG;

            var promise1 = new Promise((resolve, reject) => {
                image1.onload = function () {
                    ctx.drawImage(image1, 0, 0, 650, 900);
                    resolve("ok");
                };
            });
            promise1.then((res) => {
                if (res == "ok") {
                    //考生照片
                    var promise2 = new Promise((r1, r2) => {
                        var img = new Image();
                        img.crossOrigin = "*";
                        img.src = this.stuInfo.studentUrl + "?v=" + Math.random();
                        img.onload = function () {
                            ctx.drawImage(img, 412, 350, 95, 130);
                        };
                    });

                    // 上部年
                    ctx.font = "13px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.examTimeYear}`, 148, 362);
                    // 下部年
                    ctx.font = "15px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.examTimeYearFZ}`, 385, 775);

                    // 上部月
                    ctx.font = "13px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.examTimeMonth}`, 210, 362);

                    // 下部月
                    ctx.font = "15px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.examTimeMonthFZ}`, 450, 775);

                    // 上部日
                    ctx.font = "13px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.examTimeDay}`, 252, 362);

                    // 下部日
                    ctx.font = "15px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.examTimeDay}`, 488, 775);

                    //英文日期
                    ctx.font = "9px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.dateMoth[this.stuInfo.examTimeMonths]} ${this.stuInfo.examTimeDay} ${this.stuInfo.examTimeYear}`, 135, 556);

                    //学生姓名
                    ctx.font = "13px HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.studentName}`, 428, 518);
                    ctx.stroke();
                    // 学生姓名（拼音）
                    ctx.font = "9px HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.studentNamePinyin}`, 255, 512);
                    ctx.stroke();

                    // 身份证
                    ctx.font = "13px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.idCard}`, 428, 558);
                    // 证书编号
                    ctx.font = "13px HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.certificateNum}`, 428, 595);

                    // 级别（初级 中级 高级）
                    ctx.font = "13px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.examinationGrade}`, 200, 415);
                    //级别（初级 中级 高级）（英文）
                    ctx.font = "9px HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    let str = this.dateGradeEnglish.find((item, index) => {
                        return item.value === this.stuInfo.examinationGrade;
                    });
                    ctx.fillText(`${str.label}`, 230, 600);
                }
            });
        },
        downloadCert() {
            var canvas = document.getElementById("canvas");
            var url = canvas.toDataURL("image/png");
            var oA = document.createElement("a");
            oA.download = this.stuInfo.studentName; // 设置下载的文件名，默认是'下载'
            oA.href = url;
            document.body.appendChild(oA);
            oA.click();
            oA.remove(); // 下载之后把创建的元素删除
        },
        downloadImage(url){
            window.open(url+'?response-content-disposition=attachment');
        },
        getCerfityList() {
            this.$http
                .post("/api/XOrg/CertificateTypeManager/getCertificateType", {
                    isShowScore: this.type == 2 ? 1 : 0,
                    isShowCertificate: this.type == 1 ? 1 : 0,
                    type: 0,
                })
                .then((res) => {
                    if (res.code > 0) {
                        this.cerfityList = res.list;
                    } else {
                        return;
                    }
                });
        },
        toHome() {
            this.$router.push({
                name: "certifyIndex",
            });
        },
    },
};
</script>

<style lang="scss"></style>
